export default [
  {
    realm: 'Calimhar',
    name: 'Academia de Darkhaven',
    path: 'rd',
    from: 1,
    to: 5,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Bosque de las Hadas',
    path: 'r6w2nwk2wh',
    from: 1,
    to: 5,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Catacumbas de la Capilla',
    path: 'r6w8se7s',
    from: 15,
    to: 25,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Cementerio Oscuro',
    path: 'r4s4ws',
    clan: 'Legends',
    from: 5,
    to: 15,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Ciudad Imperial',
    path: 'r8e2n4el3e2sj',
    from: 0,
    to: 95,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'DarkHaven',
    path: 'rd',
    from: 0,
    to: 95,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Campamento Goblin',
    path: 'r10s4en3e2n',
    from: 1,
    to: 10,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Cementerio',
    path: 'r6w8ses',
    from: 5,
    to: 10,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Centinela',
    path: 'r7ws',
    from: 5,
    to: 10,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Gran Estadio',
    path: 'r8e2n4el3e2s2jn',
    from: 10,
    to: 20,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Imperio Orco',
    path: 'r13s2wn',
    clan: 'Legends',
    from: 10,
    to: 20,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Jardin de los Heroes',
    path: 'r8e2n4el3e2s2j8l8e5j4els',
    from: 75,
    to: 80,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Pantano Orco',
    path: 'r13s2en',
    clan: 'DarkAngels',
    from: 5,
    to: 30,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'El Refugio Destruido',
    path: 'r8e2ne',
    from: 5,
    to: 20,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Exportaciones de Dragones',
    path: 'r4sen',
    clan: 'Legends',
    from: 5,
    to: 25,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Foire de Reves',
    path: 'r8n3ene',
    from: 0,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Galeria de arte',
    path: 'r4swn',
    from: 10,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Guarderia Enana',
    path: 'r8ejs',
    from: 1,
    to: 5,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Haon Dor',
    path: 'r7w',
    from: 5,
    to: 10,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Holy Grove',
    path: 'r9e',
    from: 5,
    to: 20,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Kharadest, Baluarte de Platino',
    from: 78,
    to: 80,
    min: 77,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'La Fortaleza de Valor',
    path: 'r11n2en',
    clan: 'DragonSlayers',
    from: 5,
    to: 30,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'La Mansion de Marmol',
    path: 'r9w3s',
    from: 5,
    to: 15,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'La Mansion de Tullfuhrzky',
    path: 'r6w2nwk2wh4nj',
    from: 1,
    to: 10,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'La Torre del Brujo',
    path: 'r9w2sese2s',
    clan: 'Legends',
    from: 10,
    to: 20,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Las Alcantarillas',
    path: 'r4sd',
    from: 5,
    to: 20,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Las Llanuras del Norte',
    path: 'r7n',
    from: 1,
    to: 20,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: "Miden'nir",
    path: 'r7s',
    from: 5,
    to: 15,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Residencias de Mortales',
    from: 0,
    to: 95,
    min: 0,
    max: 95,
  },
  {
    realm: 'Calimhar',
    name: 'Sindaliore',
    clan: 'Legends',
    from: 75,
    to: 80,
    min: 77,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Armageddon',
    path: 'r3s7w6n2wsl2sejls',
    clan: 'Conclave',
    from: 50,
    to: 80,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Asgard',
    path: 'r3s7w11ne2n2enhjn;entrar;.s',
    clan: 'El Santuario',
    from: 40,
    to: 60,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Asoinwan, ciudad de las hadas',
    path: 'r3s7w11ne2n',
    clan: 'DragonSlayers',
    from: 5,
    to: 30,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Camelot',
    path: 'r3s7w11ne2n2ej',
    from: 65,
    to: 80,
    min: 50,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Dregoria',
    path: 'r3s5e10n3wn',
    clan: 'Cantico',
    from: 40,
    to: 65,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'El Calabozo de la Muerte',
    path: 'ruse7n',
    from: 10,
    to: 35,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'El Campo de Batalla Desolado',
    path: 'r3s7w6n2wsl2se',
    from: 15,
    to: 25,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'El Plano Astral',
    path: 'r2su',
    clan: 'DarkAngels',
    from: 15,
    to: 35,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'El Pueblo Fantasma',
    path: 'r3s5e2j',
    clan: 'DragonSlayers',
    from: 35,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'El Reino de Yggdrasil',
    path: 'r3s7w11ne2n2enhjn;entrar',
    from: 15,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'El Yunque del Sol',
    path: 'r3s7w6n2wsl2sejl2s5e4n3w2n4w',
    clan: 'Legends',
    from: 60,
    to: 80,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Estroglia, coraz�n del Yunque',
    clan: 'DarkAngels',
    from: 75,
    to: 80,
    min: 75,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Ghotiamir',
    path: 'r',
    from: 0,
    to: 95,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'La Ciudad de Velas',
    path: 'r3s7wn',
    from: 45,
    to: 55,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'La Fortaleza de Lord Krothgar',
    path: 'r3s5e3n',
    from: 35,
    to: 60,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'La Fortaleza Enana',
    path: 'r3s5el2nj',
    clan: 'El Santuario',
    from: 35,
    to: 65,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'La Guarida de Kotegaesi',
    path: 'r3s7w6n2wslsk',
    from: 30,
    to: 45,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'La tumba de Damara',
    path: 'r3s5w3n',
    clan: 'Shinsent',
    from: 15,
    to: 25,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Las Ruinas de los Antiguos',
    from: 78,
    to: 80,
    min: 77,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Observatorio del Ojo Celeste',
    path: 'r3s3e2s',
    clan: 'Cantico',
    from: 25,
    to: 65,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Valle de Rivendel',
    path: 'r3s7w11ne2n2e2n',
    from: 60,
    to: 80,
    min: 0,
    max: 95,
  },
  {
    realm: 'Earand',
    name: 'Villa Enana',
    path: 'r3s5el',
    from: 10,
    to: 35,
    min: 0,
    max: 95,
  },
  {
    realm: 'Niruk',
    name: 'La casa de Anarion',
    from: 75,
    to: 80,
    min: 75,
    max: 95,
  },
  {
    realm: 'Niruk',
    name: 'Las Tierras Desoladas',
    clan: 'DarkAngels',
    from: 10,
    to: 80,
    min: 0,
    max: 95,
  },
  {
    realm: 'Niruk',
    name: 'Residencia de Inmortales',
    from: 81,
    to: 95,
    min: 0,
    max: 95,
  },
  {
    realm: 'Niruk',
    name: "Tiempo de L'Hopital",
    from: 75,
    to: 80,
    min: 75,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Bosque de los Muertos',
    path: 'r3s5e2n2e2ses2en',
    from: 20,
    to: 40,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Dhusebark',
    path: 'r',
    from: 0,
    to: 95,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'El Devorador de Mundos',
    path: 'r3s5e2n2e2ses2e3n2wkwnwhne6nunj',
    from: 30,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'El Legado de Xchantharus',
    path: 'r3s5e2n2e3swse3sd9sh',
    clan: 'El Santuario',
    from: 30,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'El Mausoleo del Minotauro',
    path: 'r3s5e2n2en',
    from: 40,
    to: 65,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Guarida de Gigantes de Fuego',
    path: 'r3s5wh2w',
    from: 40,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Infierno',
    path: 'r4sd',
    from: 30,
    to: 80,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'La Ciudad Maldita',
    path: 'r9sk3esek',
    clan: 'Sindicato',
    from: 40,
    to: 80,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'La Fortaleza de Lilith',
    path: 'r9sk2w3usw',
    clan: 'Torre Arcana',
    from: 65,
    to: 80,
    min: 55,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'La Fortaleza de Mahn-Tor',
    path: 'r3s5e2n2e',
    from: 5,
    to: 35,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'La Gran Torre de la Hechiceria',
    path: 'r3s5e2nj',
    from: 10,
    to: 30,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'La Maldicion del Nigromante',
    path: 'r3s5e2n2e2s2e',
    clan: 'Cantico',
    from: 30,
    to: 55,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'La Residencia de Redferne',
    path: 'r9sk2w',
    from: 20,
    to: 30,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Los Pozos de la Reina Aranya',
    from: 40,
    to: 55,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Los Usurpadores de Hochenyana',
    path: 'r3s6ele',
    clan: 'Shinsent',
    from: 20,
    to: 35,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Profundidades Umbrias',
    path: 'r3s5e2n2e3swse3sd9sd',
    from: 20,
    to: 50,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Puerto Libre',
    path: 'r9ske',
    from: 10,
    to: 55,
    min: 0,
    max: 95,
  },
  {
    realm: 'Valmorag',
    name: 'Valle de Morgul',
    path: 'r9sk2w3us',
    clan: 'Shinsent',
    from: 30,
    to: 55,
    min: 0,
    max: 95,
  },
] as const;
